import Contact from './Contact';

export default function App() {
  return (
    <div className="main">

      <Contact />

    </div>
  );
}